var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CContainer',{staticClass:"d-flex align-items-center mt-2"},[_c('CRow',{staticClass:"justify-content-center col-md-12"},[_c('CCard',{staticClass:"text-center col-md-6",attrs:{"color":"white","text-color":"dark","body-wrapper":""}},[_c('div',[_c('h3',[_vm._v("checkout success")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }